<template>
    <div class="map-container" :style="styles">
      <div id="container"></div>
    </div>
</template>

<script>
export default {
  props: {
    data:{
        type:Object,
        default:function(){
            return {}
        }
    },
    loading:{
        type:Boolean,
        default:false
    }
  },
  components: {

  },
  data() {
    return {
        resData:this.data,
        time: 1000 * 60 * 30,
        timer: null,
        tableData: [],
        path: [],
        activePath: [],
        pl: [],
        pl1:[],
        activePl: [],
        lat: [],
        activeLat: [],
        latLable: [],
        count:0,
        flag: false,
        key: this.data.mapKey||'CLPBZ-WR2CJ-LEQFQ-K2DEE-7YTFZ-XGFDR',
        map: null,
        center: null,
        infoWindow: null,
        offset: 5,
        perIndex: 0,
        isCity:false,
        loadings:this.loading,
        hasTime:true,
        zoom:4,
        hasLat:true,
        centerLat:[39.90923,116.397428],
        mapLoad:false,
        styles:{},
        sendCity:true
    }    
  },
  created(){
      window.loadingMap = this.loadingMap
  },
  mounted() {
      this.loadScript()
  },
  computed: {
    getTime() {
      let len = this.path.length,lens = this.tableData.length
      let start = new Date().getTime();
      if(lens){
        start = this.tableData[lens - 1].AcceptTime.replace(/-/g, "/")
      }
      let init = 1000*3600*24*4,
          startTime = new Date(start).getTime(),
          nowTime = new Date().getTime(),
          tempTime = [new Date().getFullYear(),new Date().getMonth()+1,new Date().getDate()].join('/')+' 23:59:59',
          dayTime = new Date(tempTime).getTime()
      let time = startTime+init;
      if(this.resData.EstimatedDeliveryTime){
        let end = this.resData.EstimatedDeliveryTime.replace(/-/g, "/")
        let endTime = new Date(end).getTime()
        let stateEx = +this.resData.StateEx
        if(endTime<=dayTime||stateEx==202||stateEx==211){
          return '今天'
        }else{
          time = this.resData.EstimatedDeliveryTime.split(" ")[0];
        }
      }
      time = this.$tool.formatDate(time,'MM.dd')+'前'
      return time;
    },
    carDot() {
      let car = null;
      let activeLen = this.path.length
      let isLeft = true;
      if(activeLen>=2){
          let startLng = this.path[activeLen-2].LatAndLng.split(',')[1],
              endLng = this.path[activeLen-1].LatAndLng.split(',')[1];
              isLeft = startLng-endLng<=0
      }
      if (this.per > 0&&!this.state()) {
          let label = this.tableData[0]&&this.tableData[0].Location
          if(this.tableData[1]&&this.tableData[1].Location){
            label = this.tableData[1].Location
          }
          car = {
            lat: this.activePl[this.activePl.length-1],
            label,
            isLeft
          };
        }
      if(!this.sendCity){
        car = {
          lat : this.latLable[this.latLable.length - 1].lat,
          label:this.latLable[this.latLable.length - 1].label,
          isLeft
        }
      }
      return car;
    },
    per(){
      let per = 0
      if (this.resData.EstimatedDeliveryTime && this.tableData.length) {
        let city = this.tableData[0].Location,
            city1 =this.path.length&&this.path[this.path.length-1].Location
        let len = this.tableData.length,
          end = this.resData.EstimatedDeliveryTime.replace(/-/g, "/"),
          endTime = new Date(end).getTime(),
          start = this.tableData[len - 1].AcceptTime.replace(/-/g, "/"),
          nowTime = new Date().getTime(),
          startTime = new Date(start).getTime()
        let state = +this.resData.State, stateEx = + this.resData.StateEx
        per = (nowTime-startTime) / (endTime-startTime)
        if(!this.state()){
          if(stateEx==211||stateEx==202||stateEx==202){
            per = 0.95
            if(stateEx==211){
              per = 0.99
            }
            this.hasTime = true
          }else if(state==4){
            per = 0.9
          }else{
            if(!this.hasTime){
              per = 0.6
            }
          }
          if(city==city1){
            per = 0.9
          }
        }
        if(state===1){
          per=0
        }
        if(per<=0){
          per = 0
        }else if(per>=1){
          per = 0.95
        }
      }
      return per
    },
    isIE() {
      if(window.ActiveXObject || "ActiveXObject" in window){
        return true;
      }else{
        return false;
  　　}
    }
  },
  watch: {
    data(val){
      this.resData = val
      this.getData()
    },
    loading(val){
        this.loadings = val
    },
    loadings(val){
        this.$emit('update:loading',val)
    }
  },
  methods: {
    loadScript(){
      if(this.key){
        var script = document.createElement("script")
        script.src="https://map.qq.com/api/gljs?v=1.exp&callback=loadingMap&key="+this.key
        script.type="text/javascript"
        document.body.appendChild(script)
      }
    },
    loadingMap(){
      if(window.TMap){
        this.setCss()
        this.center = new TMap.LatLng(...this.centerLat)
        this.map = new TMap.Map("container", {
          center: this.center, //地图显示中心点
          zoom:this.zoom, //缩放级别
        });
        this.mapLoad = true;
        this.getData()
      }
    },
    setCss(){
      let height=this.$route.query.height;
      if(height){
        if(height.indexOf("px")<0&&height.indexOf("vh")<0){
          if(Number(height)){
            height = Number(height)+"px"
          }
        }
      }
      this.styles={
        height
      }
    },
    changeZoom(){
      this.map.easeTo({zoom:this.zoom,rotation:0},{duration: 2000});
    },
    state(){
      let state = +this.resData.State, stateEx = +this.resData.StateEx;
      if(state==3){
        return true
      }
      return false
    },
    getCity(){
      let state = +this.resData.State, stateEx = +this.resData.StateEx;
      if(stateEx>2&&stateEx!=401){
        return true
      }
      return false
    },
    getData() {
        if(!this.resData.Success||!this.mapLoad){
            return
        }
        if(this.isIE){
            this.$message('地图暂不兼容IE，请使用其它浏览器')
            this.loadings = false
            return
        }
        let data = this.resData;
        let EstimatedDeliveryTime = data.EstimatedDeliveryTime;
        if(!EstimatedDeliveryTime){
          this.hasTime = false
        }
        this.resData.EstimatedDeliveryTime = this.$tool.formatDate(EstimatedDeliveryTime)
        this.tableData = data.Traces || [];
        this.path = data.PreCoordinates || [];
        this.activePath = data.Coordinates || [];
        let tempArr = data.Coordinates||[]
        tempArr.forEach((ele)=>{
            if(!ele.LatAndLng){
              this.hasLat = false
            }
        })
        if(data.PreCoordinates.length===2&&data.PreCoordinates[0].LatAndLng===data.PreCoordinates[1].LatAndLng){
          this.isCity = true;
        }
        if(this.activePath.length&&!this.getCity()&&this.hasLat&&!this.isCity){
            if(!this.getCity()&&this.activePath.length&&this.path.length){
                let temp = data.PreCoordinates
                this.path = this.activePath
                let end = temp[temp.length-1],
                last = this.path[this.path.length-1]
                if(end.LatAndLng!==last.LatAndLng){
                    this.path.push(end)
                }
            }
        }
        if(data.CityIsNull||data.PreCoordinates.length==0){
          this.sendCity = false
        }
        if(this.getCity()||data.CityIsNull||data.PreCoordinates.length==0){
          if(this.getCity()){
            this.isCity = false;
          }
          this.path = this.activePath
        }
        if(this.map){
          this.initMap() 
        }                
    },
    initMap() {
      let temp = this.setCenter(this.path)
      this.center = new TMap.LatLng(...temp);
      this.map.setCenter(this.center);
      this.changeZoom()
      this.getLat();
      this.createDom();
      this.onlyCity();
      if(this.path.length>=2&&this.hasLat&&!this.isCity){
        this.path.reduce((from, to, index) => {
            this.getJson(from.LatAndLng, to.LatAndLng, index, true);
            return to;
          });
      }
      setTimeout(() => {
          this.loadings = false;
      }, 800);
    },
    onlyCity(){
      if(this.path.length==1||this.isCity){
        this.setDot();
        let sendDot =this.latLable[0] || this.latLable[0]
        let send = new CreateDom({
          map: this.map,
          position: sendDot.lat,
          content: "",
        });
        if(this.isCity){
          send.updateContent5({
            left: '同城件',
            right: sendDot.label,
          });
        }else if(this.state()){
          send.updateContent2({
              left: require("@/assets/images/map1.png"),
              right: {
                label:sendDot.label,
                time:this.getSignTime()
              }
          });
        }else{
          send.updateContent({
            left: '发',
            right: sendDot.label,
          });
        }
        
      }
    },
    setCenter(path){
      let temp =this.centerLat;
      if(path.length&&path[0].LatAndLng){
        let start = path[0].LatAndLng.split(","),end = path[path.length-1].LatAndLng.split(","),
            cutStart = Number(start[0])-Number(end[0]),cutEnd = Number(start[1])-Number(end[1]),
            lat = (cutStart)/2+Number(end[0]),lng = (cutEnd)/2+Number(end[1]);
        this.zoom = 5
        if(Math.abs(cutStart)<=3&&Math.abs(cutEnd)<=5){
          this.zoom = 6
        }
        if(Math.abs(cutStart)<=1&&Math.abs(cutEnd)<=2){
          this.zoom = 7
        }
        if(Math.abs(cutStart)>=8||Math.abs(cutEnd)>=8){
          this.zoom = 5.5
        }
        if(Math.abs(cutStart)>=10||Math.abs(cutEnd)>=10){
          this.zoom = 5
        }
        if(Math.abs(cutStart)>=20||Math.abs(cutEnd)>=30){
            this.zoom = 4.5
        }
        if(Math.abs(cutStart)>=30||Math.abs(cutEnd)>=40){
            this.zoom = 4
        }
        temp = [lat,lng]
      } 
      return temp
    },
    getResult(){
      let len = this.path.length;
      let arr = [];
      for(let i = 1;i<len;i++){
        let p = new Promise((res,rej)=>{
          window["cb"+i] = (ret)=>{
            if(ret&&ret.result&&ret.result.routes&&ret.result.routes.length){  
                res(ret.result.routes)
            }else{
                this.count ++
                this.show = false
                if(this.count==1){
                  this.$message(ret.message||'地图加载失败，请重试')
                }
                rej(ret.message)
            }
          }
        });
        arr.push(p)
      }
      Promise.all(arr).then(res=>{
        let path = [],path1 = [],activePath = []
        res.forEach((ele,index)=>{
          var coords = ele[0].polyline,
            pl = [];
          //坐标解压（返回的点串坐标，通过前向差分进行压缩）
          var kr = 1000000;
          for (var i = 2; i < coords.length; i++) {
            coords[i] = Number(coords[i - 2]) + Number(coords[i]) / kr;
          }
          //将解压后的坐标放入点串数组pl中
          for (var i = 0; i < coords.length; i += 2) {
            let lat = new TMap.LatLng(coords[i], coords[i + 1]);
            pl.push(lat);
          }
          if(res.length-1==index){
            path1=pl //截取最后一段路线
          }else{
            activePath = activePath.concat(pl) //截取除最后一段的路线
          }
          path = path.concat(pl)
        })
        if(this.sendCity){
          let perIndex = parseInt(this.per*path1.length)
          activePath = activePath.concat(path1.slice(0,perIndex))
          this.activePl = activePath;
        }
        this.polyline(path)
      }).catch(err=>{
        console.log(err)
      })
    },
    getJson(from, to, index) {
      let url = `https://apis.map.qq.com/ws/direction/v1/driving/?from=${from}&to=${to}&output=jsonp&callback=cb${index}&key=${this.key}`;
      let script = document.createElement("script");
      script.src = url;
      document.body.appendChild(script);
      if(this.path.length-1===index){
         this.getResult()
      }
    },
    polyline(pl) {
      let pl1 = this.activePl
      this.setDot();
      this.setMaker();
      this.initCarMaker()
      if(this.state()){
        new TMap.MultiPolyline({
            id: "poly", //图层唯一标识
            map: this.map, //绘制到目标地图
            //折线样式定义
            styles: {
              style_blue: new TMap.PolylineStyle({
                color:"#1461E5", //线填充色
                width: 4, //折线宽度
                lineCap: "round", //线端头方式
              })
            },
            //折线数据定义
            geometries: [
              {
                id: "pl_1", //折线唯一标识，删除时使用
                styleId: "style_blue", //绑定样式名
                paths: pl,
              }
            ],
        });
      }else{
          this.setCarMaker();
          this.setCarDot();
        if(pl1.length){
          new TMap.MultiPolyline({
            id: "poly", //图层唯一标识
            map: this.map, //绘制到目标地图
            //折线样式定义
            styles: {
              style_blue: new TMap.PolylineStyle({
                color:"#78AAFF", //线填充色
                width: 4, //折线宽度
                lineCap: "round", //线端头方式
              }),
              style_blue1: new TMap.PolylineStyle({
                color:"#1461E5", //线填充色
                width: 4, //折线宽度
                lineCap: "round", //线端头方式
              }),
            },
            //折线数据定义
            geometries: [
              {
                id: "pl_1", //折线唯一标识，删除时使用
                styleId: "style_blue", //绑定样式名
                paths: pl,
              },
              {
                id: "pl_2", //折线唯一标识，删除时使用
                styleId: "style_blue1", //绑定样式名
                paths: pl1,
              },
            ],
          });
        }else{
          let color = "#78AAFF"
          if(!this.sendCity){
            color= "#1461E5"
          }
          new TMap.MultiPolyline({
            id: "poly", //图层唯一标识
            map: this.map, //绘制到目标地图
            //折线样式定义
            styles: {
              style_blue: new TMap.PolylineStyle({
                color, //线填充色
                width: 4, //折线宽度
                lineCap: "round", //线端头方式
              })
            },
            //折线数据定义
            geometries: [
              {
                id: "pl_1", //折线唯一标识，删除时使用
                styleId: "style_blue", //绑定样式名
                paths: pl,
              }
            ],
          });
        }
      }
    },
    getSignTime(){
      let signTime = null,
      year = new Date().getFullYear();
      let time = null;
      if(this.tableData.length){
        signTime = this.tableData[0].AcceptTime.split(' ')[0]
        if(year === +signTime.split('-')[0]){
          time = signTime.split('-')[1]+'月'+signTime.split('-')[2]+'日已签收'
        }else{
          time = signTime.split('-')[0] +'年' + signTime.split('-')[1]+'月'+signTime.split('-')[2]+'日已签收'
        }
      }
      return time
    },
    setMaker() {
      let receiveDot =this.latLable[this.latLable.length-1]|| this.latLable[this.latLable.length - 1],
        sendDot =this.latLable[0] || this.latLable[0],
        signDot = this.latLable[this.latLable.length-1]|| this.latLable[this.latLable.length - 1];
      let receive = new CreateDom({
        map: this.map,
        position: receiveDot.lat,
        content: "",
      });
      let send = new CreateDom({
        map: this.map,
        position: sendDot.lat,
        content: "",
      });
      let sign = new CreateDom({
        map: this.map,
        position: signDot.lat,
        content: "",
      });
      let time = this.getSignTime()
      if(!this.isCity){
        send.updateContent({
          left: "发",
          right: sendDot.label,
        });
        if(this.sendCity){
          receive.updateContent({
            left: "收",
            right: receiveDot.label,
          });
        }else{
          receive.updateContent6({
            left: "所在城市",
            right: receiveDot.label,
          });
        }
      }else{
        send.updateContent5({
          left: "同城件",
          right: sendDot.label,
        });
      }
      if(this.state()){
        sign.updateContent2({
            left: require("@/assets/images/map1.png"),
            right: {
              label:signDot.label,
              time
            }
        });
        receive.hidden()
      }
    },
    getLat() {
      this.path.map((ele) => {
        if(ele.LatAndLng){
          let temp = ele.LatAndLng.split(",");
          this.latLable.push({
            lat: new TMap.LatLng(...temp),
            label: ele.Location,
          });
          this.lat.push(new TMap.LatLng(...temp));
        }
      });
    },
    setCarMaker() {
      let carDot = this.carDot
      if (carDot && carDot.lat&&!this.state()&&!this.isCity) {
        let car = new CreateDom({
          map: this.map,
          position: carDot.lat,
          content: "",
        });
        car.updateContent1({
          left: this.getTime,
          right: carDot.label,
        });
      }
    },
    initCarMaker(){
      if(this.latLable.length==1&&!this.state()&&!this.isCity){
        let carDot = this.latLable[0]
        let car = new CreateDom({
          map: this.map,
          position: carDot.lat,
          content: "",
        });
        car.updateContent1({
          left: this.getTime,
          right: carDot.label,
        });
      }
    },
    setDot(){
      this.lat.forEach((ele) => {
        let dot = new CreateDom({
          map: this.map,
          position: ele,
          content: "",
        });
        dot.updateContent3();
      });
    },
    setCarDot() {
      let carDot = this.carDot
      if (carDot && carDot.lat && !this.state()&&!this.isCity) {
        let marker = new CreateDom({
          map: this.map,
          position: carDot.lat,
          content: "",
        });
        marker.updateContent4({
          left:require('@/assets/images/map3.png'),
          isLeft:carDot.isLeft
        });
      }
    },
    createDom() {
      let _this = this;
      function CreateDom(options) {
        TMap.DOMOverlay.call(this, options);
      }

      function initStyle(style) {
        let arr = [];
        for (let key in style) {
          let str = "";
          arr.push(str + toLowerLine(key) + ":" + style[key]);
        }
        return arr.join(";");
      }

      function toLowerLine(str) {
        var temp = str.replace(/[A-Z]/g, function(match) {
          return "-" + match.toLowerCase();
        });
        if (temp.slice(0, 1) === "-") {
          temp = temp.slice(1);
        }
        return temp;
      }

      CreateDom.prototype = new TMap.DOMOverlay();

      // 初始化
      CreateDom.prototype.onInit = function(options) {
        this.position = options.position;
        this.content = options.content;
      };

      // 创建DOM元素，返回一个DOMElement
      CreateDom.prototype.createDOM = function() {
        let mydom = document.createElement("div");
        mydom.setAttribute("class", "mydom");
        //设置DOM样式
        mydom.style.cssText = initStyle({
          position: "absolute",
          top: 0,
          left: 0,
          height: "30px",
          width: "250px"
        });
        mydom.innerHTML = this.content;
        this.onClick = () => {
          this.emit("click");
        };
        this.onTouchstart = () => {
          this.emit("touchstart");
        };
        mydom.addEventListener("click", this.onClick);
        mydom.addEventListener("touchstart", this.onTouchstart);
        return mydom;
      };

      CreateDom.prototype.updateStyle = function(style) {
        let str = this.dom.style.cssText;
        this.dom.style.cssText = str + initStyle(style);
        this.updateDOM();
      };
      // 更新DOM元素，在地图移动/缩放后执行
      CreateDom.prototype.updateDOM = function() {
        if (!this.map) {
          return;
        }

        // 经纬度坐标转容器像素坐标
        let pixel = this.map.projectToContainer(this.position);

        //默认使用DOM左上角作为坐标焦点进行绘制（左上对齐）
        //如想以DOM中心点（横向&垂直居中）或其它位置为焦点，可结合this.dom.clientWidth和this.dom.clientHeight自行计算
        let left = pixel.getX() - this.dom.clientWidth / 2 + "px";
        let top = pixel.getY() - this.dom.clientHeight / 2 + "px";
        // let left = pixel.getX() + _this.offset + "px";
        // let top = pixel.getY() + _this.offset + "px";
        //将平面坐标转为三维空间坐标
        this.dom.style.transform = `translate3d(${left}, ${top}, 0px)`;
      };

      //自定义一个更新内容的方法
      CreateDom.prototype.updateContent = function(content) {
        this.dom.innerHTML = `<div class="map-maker">
                                <div class="left">${content.left}</div>
                                <div class="right">
                                  ${content.right}
                                </div>
                              </div>`;
      };
      CreateDom.prototype.updateContent1 = function(content) {
        let display = _this.hasTime?'block':'none'
        this.dom.setAttribute('class','mydom mydom2')
        this.dom.innerHTML = `<div class="map-maker1" style="display:${display}">
                                <div class="remove-btn"><i class="el-icon-close"></i></div>
                                <div class="left">预计${content.left}送达</div>
                                <div class="right" style="display:none">当前离开${content.right}</div>
                              </div>`;
        this.dom
          .getElementsByClassName("remove-btn")[0]
          .addEventListener("click", () => {
            this.dom.style.display = "none";
          });
        this.dom
          .getElementsByClassName("remove-btn")[0]
          .addEventListener("touchstart", () => {
            this.dom.style.display = "none";
          });
      };
      CreateDom.prototype.updateContent2 = function(content) {
        this.dom.innerHTML = `<div class="map-maker map-maker2">
                                <div class="left"><img src="${content.left}"></div>
                                <div class="right">
                                  <p>${content.right.label}<p/>
                                  <p>${content.right.time}<p/>
                                </div>
                              </div>`;
      };
      CreateDom.prototype.updateContent3 = function(content) {
        this.dom.setAttribute('class','mydom mydom1')
        this.dom.innerHTML = `<div class="map-maker3"></div>`;
      };
      CreateDom.prototype.updateContent4 = function(content) {
        let names = content.isLeft?'':'rotate'
        this.dom.setAttribute('class','mydom mydom1')
        this.dom.innerHTML = `<div class="map-maker4 ${names}"><img src="${content.left}" /></div>`;
      };
      CreateDom.prototype.updateContent5 = function(content) {
        this.dom.innerHTML = `<div class="map-maker map-maker5">
                                <div class="left">${content.left}</div>
                                <div class="right">
                                  ${content.right}
                                </div>
                              </div>`;
      };
      CreateDom.prototype.show = function() {
        this.dom.style.display = "block";
      };
      CreateDom.prototype.hidden = function() {
        this.dom.style.display = "none";
      };
      CreateDom.prototype.updateContent6 = function(content) {
        this.dom.innerHTML = `<div class="map-maker map-maker6">
                                <div class="left">${content.left}</div>
                                <div class="right">
                                  ${content.right}
                                </div>
                              </div>`;
      };
      window.CreateDom = CreateDom;
    }
  },
};
</script>

<style scoped lang="scss">

</style>
